/* ============================================================
   Post-lead qualification quiz (thanks page).

   Brief (ТЗ «Додаткова кваліфікація ліда після заявки»):
     · the visitor has ALREADY left a lead — this quiz only enriches it;
     · 4 questions, answers land in the CRM card of the SAME lead
       (no new lead is created);
     · every answer is sent immediately, so closing the tab never
       loses what was already answered;
     · Qualification status: Not started → In progress → Completed.

   Linkage: app.js generates a lead_ref, puts it INTO the lead payload
   and into sessionStorage; every answer here carries the same ref
   (plus lead_id when the server provided one, e.g. the WP plugin).
   The CRM matches by lead_ref / lead_id and appends the fields.

   Configured by window.QUIZ_CONFIG (set in the thanks page <head>):
     {
       prefix:   'clm_employment',      // sessionStorage namespace of app.js
       partner:  'employment-law',
       endpoint: '',                    // where answers go; '' = console+localStorage
       leadId:   '',                    // server lead id, if known (WP passes ?lid=)
       questions: [{ field, q, options: [{ code, label }] }],
       i18n: { progress: 'Question %1 of %2', doneTitle, doneText }
     }
   ============================================================ */
(function () {
  'use strict';

  var C = window.QUIZ_CONFIG;
  var root = document.getElementById('quiz');
  if (!C || !root || !C.questions || !C.questions.length) return;

  var PREFIX = C.prefix || 'clm';
  var REF_KEY = PREFIX + '_lead_ref';
  var STORE_KEY = PREFIX + '_quiz';
  var STATUS = { none: 'Not started', progress: 'In progress', done: 'Completed' };

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  var leadRef = ss(true, REF_KEY) || '';
  var leadId = C.leadId || '';

  var saved = {};
  try { saved = JSON.parse(ss(true, STORE_KEY) || '{}'); } catch (e) { saved = {}; }
  if (!saved.answers) saved.answers = {};
  /* A fresh lead (new lead_ref) starts a fresh quiz: without this, a repeat
     request from the same visitor would show the previous "done" state and
     attach answers to the old lead. */
  if (saved.ref !== leadRef) saved = { ref: leadRef, answers: {} };

  function persist() { ss(false, STORE_KEY, JSON.stringify(saved)); }

  function status() {
    var n = Object.keys(saved.answers).length;
    if (n === 0) return STATUS.none;
    return n >= C.questions.length ? STATUS.done : STATUS.progress;
  }

  /* -------- transport: each answer goes out on its own, at once ------- */
  function send(field, code, label) {
    var payload = {
      type: 'lead_qualification',
      partner: C.partner || '',
      lead_ref: leadRef,
      lead_id: leadId,
      field: field,
      value: label,          /* the human answer, as the brief requires */
      value_code: code,      /* stable machine code for analytics */
      qualification_status: status(),
      page: location.href,
      ts: new Date().toISOString()
    };
    console.info('[qualify]', payload);
    try {
      var arr = JSON.parse(localStorage.getItem(PREFIX + '_qualify') || '[]');
      arr.push(payload);
      localStorage.setItem(PREFIX + '_qualify', JSON.stringify(arr.slice(-100)));
    } catch (e) {}
    if (C.endpoint) {
      try {
        /* keepalive: the 4th answer often precedes closing the tab */
        fetch(C.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'lead_qualification',
        q_field: field, q_value: code, q_status: payload.qualification_status
      });
    }
  }

  /* ------------------------------ UI ------------------------------ */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function nextIndex() {
    for (var i = 0; i < C.questions.length; i++) {
      if (!(C.questions[i].field in saved.answers)) return i;
    }
    return -1;
  }

  function render() {
    root.innerHTML = '';
    var i = nextIndex();
    if (i === -1) { renderDone(); return; }
    var q = C.questions[i];

    var card = el('div', 'quiz-card');
    card.appendChild(el('p', 'quiz-progress',
      (C.i18n.progress || 'Question %1 of %2').replace('%1', i + 1).replace('%2', C.questions.length)));
    card.appendChild(el('h3', 'quiz-q', q.q));

    var list = el('div', 'quiz-opts');
    q.options.forEach(function (o) {
      var b = el('button', 'quiz-opt', o.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        if (b.classList.contains('is-sent')) return;
        b.classList.add('is-sent');
        saved.answers[q.field] = { code: o.code, label: o.label };
        persist();
        send(q.field, o.code, o.label);
        setTimeout(render, 180);   /* short beat so the tap is visible */
      });
      list.appendChild(b);
    });
    card.appendChild(list);
    root.appendChild(card);
  }

  function renderDone() {
    if (!saved.done) {
      saved.done = true;
      persist();
      if (window.dataLayer) window.dataLayer.push({ event: 'lead_qualification_completed' });
    }
    var card = el('div', 'quiz-card quiz-card--done');
    var badge = el('div', 'quiz-done-badge');
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.4 4.4L19.5 6.5"/></svg>';
    card.appendChild(badge);
    card.appendChild(el('h3', 'quiz-q', C.i18n.doneTitle || 'Thank you!'));
    card.appendChild(el('p', 'quiz-done-text', C.i18n.doneText || ''));
    root.innerHTML = '';
    root.appendChild(card);
  }

  render();
})();